import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, empty, map, Observable, of, shareReplay } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { VisibilityPollingService } from '../visibility-polling/visibility-polling.service';

interface BulkUpdatePayload {
  references: string[];
  stage: string;
}

interface BulkUpdateResponse {
  message: string;
  data: any;
}
@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  private apiUrlPublic = environment.apiURL;
  private apiUrl = environment.apiURL + 'orders'; // URL del API
  private apiUrlW = environment.apiURL + 'order-watchers';
  private apiUrlNotes = environment.apiURL + 'order-notes'; // URL del API

  private apiUrlLogs = environment.apiURL + 'order-logs'; // URL del API
  private apiUrlAcc = environment.apiURL + 'accounts';
  private apiUrlDelivery = environment.apiURL + 'delivery-data';
  private apiUrlTelemarketingStatus = environment.apiURL + 'telemarketing-status';
  private apiUrlTelemarketingActionStatus = environment.apiURL + 'telemarketing-action-status';
  private apiUrlSeller = environment.apiURL + 'supplier-seller-codes';
  private apiExcel = environment.apiURL + 'import';

  // Cache de datos maestros (estáticos/semi-estáticos)
  private deliveryCache$: Observable<any> | null = null;
  private tmStatusCache$: Observable<any> | null = null;
  private tmActionStatusCache$: Observable<any> | null = null;
  private tagsCache$: Observable<any> | null = null;
  private sellerCodesCache$: Observable<any> | null = null;
  private accountsCache$: Observable<any> | null = null;

  constructor(private http: HttpClient, private visibilityPolling: VisibilityPollingService) { }

  getData(
    type: string = 'contracts',
    pretype: string = 'stages',
    pageNumber: number = 1,
    pageSize: number = 10,
    params: any = {},
    sortColumn: string = 'stage_updated_at',
    sortDirection: string = 'asc'
  ): Observable<any> {
    let url = `${this.apiUrl}`;
    if (type === '') {
      url = `${this.apiUrl}`;
    } else {
      url = `${this.apiUrl}/${pretype}/${type}`;
    }
    return this.http.get(url, {
      params: {
        page: pageNumber.toString(),
        pageSize: pageSize.toString(),
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        ...params,
      },
    });
  }

  getExportColumns(headerType: string = 'all'): Observable<any> {
    return this.http.get(`${this.apiUrl}/export/columns`, {
      params: { header_type: headerType }
    });
  }

  exportData(
    type: string = 'contracts',
    params: any = {},
  ): Observable<any> {
    const specialRoutes = ['telemarketing-pending'];

    if (specialRoutes.includes(type)) {
      return this.exportTelemarketingData(params);
    }

    let url = `${this.apiUrl}/export`;

    return this.http.get(url, {
      params: {
        ...params,
      },
    });
  }

  exportTelemarketingData(params: any = {}): Observable<any> {
    const url = `${this.apiUrl}/export`;

    const telemarketingParams: any = {
      telemarketing: '1',
      format: params['format'] || 'xlsx',

    };

    if (params['telemarketing_action_type']) {
      telemarketingParams['telemarketing_action_type'] = params['telemarketing_action_type'];
    }
    /*  Object.keys(params).forEach(key => {
       if (!['stage_type', 'format', 'header_type'].includes(key) && params[key]) {
         telemarketingParams[key] = params[key];
       }
     });  */
    return this.http.get(url, { params: telemarketingParams });
  }

  deleteOrder(reference: string): Observable<any> {
    return this.http.delete(this.apiUrl + '/' + reference + '/delete');
  }
  getDataToInvoices(params: any = {}): Observable<any> {
    var url = `${this.apiUrl}/to-invoices`;
    return this.http.get(url, {
      params: {
        ...params,
      },
    });
  }

  getFilterData(
    type: string = 'contracts',
    pretype: string = 'stages',
    pageNumber: number = 1,
    pageSize: number = 10,
    params: any = {},
    sortColumn: string = 'stage_updated_at',
    sortDirection: string = 'asc'
  ): Observable<any> {


    let url = `${this.apiUrl}`;
    if (type === '') {
      url = `${this.apiUrl}`;
    } else {
      url = `${this.apiUrl}/${pretype}/${type}`;
    }

    return this.http.get(url, {
      params: {
        page: pageNumber.toString(),
        pageSize: pageSize.toString(),
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        ...params,
      },
    });
  }
  getDataByReference(reference: string = ''): Observable<any> {
    const url = `${this.apiUrl}/${reference}`;
    return this.http.get(url);
  }

  getStages(): Observable<any> {
    return this.http.get(`${this.apiUrl}/stages`);
  }

  arrayPORONGA = ['', 'telemarketing-pending', 'telemarketing-done', 'all', 'dealership-accessories', 'registering', 'pre-delivery', 'plates', 'documentation', 'washing', 'logistics',];
  getStagesMap(item: any, preType: string): Observable<any> {
    item = this.arrayPORONGA.includes(item) ? 'all' : item;
    return this.http.get(`${this.apiUrl}/stages/map/` + item);
  }

  getTimeline(item: any): Observable<any> {
    return this.http.get(this.apiUrlLogs + '/timeline/' + item);
  }
  // Método para añadir datos a la API
  addData(item: any): Observable<any> {
    return this.http.post(this.apiUrl + '/new', item);
  }

  addNotes(item: any): Observable<any> {
    return this.http.post(this.apiUrlNotes + '/new', item);
  }


  getNotes(orderReference: string, visibility: string): Observable<any> {
    return this.http.get(
      `${this.apiUrlNotes}/order/${orderReference}/${visibility}`
    );
  }

  deleteNote(reference: string): Observable<any> {
    return this.http.delete(`${this.apiUrlNotes}/${reference}/delete`);
  }
  uploadDocumentPdf(formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/new/documents`, formData);
  }
  uploadExcel(formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/import/update`, formData);
  }

  getPrivateNotesLast(
    pageNumber: number = 1,
    pageSize: number = 10,
    params: any = {},
    sortColumn: string = 'created_at',
    sortDirection: string = 'desc'
  ): Observable<any> {
    var url = `${this.apiUrlNotes}/last/private`;

    return this.http.get(url, {
      params: {
        page: pageNumber.toString(),
        pageSize: pageSize.toString(),
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        ...params,
      },
    });
  }

  getNotesLast(
    pageNumber: number = 1,
    pageSize: number = 10,
    params: any = {},
    sortColumn: string = 'created_at',
    sortDirection: string = 'desc'
  ): Observable<any> {
    var url = `${this.apiUrlNotes}/last`;

    return this.http.get(url, {
      params: {
        page: pageNumber.toString(),
        pageSize: pageSize.toString(),
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        ...params,
      },
    });
  }

  getDeliveryData(): Observable<any> {
    if (!this.deliveryCache$) {
      this.deliveryCache$ = this.http.get(this.apiUrlDelivery).pipe(shareReplay({ bufferSize: 1, refCount: false }));
    }
    return this.deliveryCache$;
  }

  getTelemarketingStatus(): Observable<any> {
    if (!this.tmStatusCache$) {
      this.tmStatusCache$ = this.http.get(this.apiUrlTelemarketingStatus).pipe(shareReplay({ bufferSize: 1, refCount: false }));
    }
    return this.tmStatusCache$;
  }
  getTelemarketingActionStatus(): Observable<any> {
    if (!this.tmActionStatusCache$) {
      this.tmActionStatusCache$ = this.http.get(this.apiUrlTelemarketingActionStatus).pipe(shareReplay({ bufferSize: 1, refCount: false }));
    }
    return this.tmActionStatusCache$;
  }

  getTags(): Observable<any> {
    if (!this.tagsCache$) {
      this.tagsCache$ = this.http.get(environment.apiURL + 'tags?pageSize=9999').pipe(shareReplay({ bufferSize: 1, refCount: false }));
    }
    return this.tagsCache$;
  }
  getSupplierSellerCodes(): Observable<any> {
    if (!this.sellerCodesCache$) {
      this.sellerCodesCache$ = this.http.get(this.apiUrlSeller).pipe(shareReplay({ bufferSize: 1, refCount: false }));
    }
    return this.sellerCodesCache$;
  }
  updateTags(reference: string, body: any): Observable<any> {
    this.tagsCache$ = null;
    return this.http.post(this.apiUrl + '/' + reference + '/tags', body);
  }
  deleteTags(reference: string, body: any): Observable<any> {
    return this.http.delete(this.apiUrl + '/' + reference + '/tags', { body });
  }
  // Método para añadir datos a la API
  searchOrder(reference: string): Observable<any> {
    return this.http.get(this.apiUrl + '/' + reference);
  }
  searchPro(searchText: string): Observable<any> {
    return this.http.get(this.apiUrl + '/search', {
      params: {
        search: searchText
      }
    });
  }

  // Método para añadir datos a la API
  updateData(reference: string, body: any): Observable<any> {
    return this.http.put(this.apiUrl + '/' + reference + '/update', body);
  }

  updateStatus(reference: string, body: any): Observable<any> {
    return this.http.put(this.apiUrl + '/' + reference + '/update-stage', body);
  }

  updateStage(reference: string, body: any): Observable<any> {
    return this.http.patch(this.apiUrl + '/' + reference + '/update-stage', body);
  }

  duplicateOrder(reference: string): Observable<any> {
    return this.http.get(this.apiUrl + '/' + reference + '/duplicate');
  }

  duplicateIntoOffer(reference: string, body: any): Observable<any> {
    return this.http.post(this.apiUrl + '/' + reference + '/duplicate-into-offer', body);
  }

  // SQL Wizard endpoints
  getSqlPrefill(token: string): Observable<any> {
    return this.http.get(this.apiUrl + '/sql/prefill/' + token);
  }

  validateOrder(body: any): Observable<any> {
    return this.http.post(this.apiUrl + '/validate', body);
  }

  createSqlOrder(body: any): Observable<any> {
    return this.http.post(this.apiUrl + '/sql', body);
  }

  //filtered orders
  getOrders(params: any = {}): Observable<any> {
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        httpParams = httpParams.set(key, params[key]);
      }
    }
    return this.http.get<any>(`${this.apiUrl}`, {
      params: httpParams,
    });
  }

  searchOrders(search: string): Observable<any> {
    return this.http.get<any[]>(`${this.apiUrl}?search=${search}`);
  }

  searchOrdersByFilter(filters: { [key: string]: string }): Observable<any> {
    let url = `${this.apiUrl}`;
    const params = [];

    for (const key in filters) {
      if (filters.hasOwnProperty(key) && filters[key]) {
        params.push(`${key}=${filters[key]}`);
      }
    }

    if (params.length > 0) {
      url += '?' + params.join('&');
    }

    return this.http.get<any>(url);
  }

  getAccounts(): Observable<any> {
    if (!this.accountsCache$) {
      this.accountsCache$ = this.http.get<any>(`${this.apiUrlAcc}`).pipe(shareReplay({ bufferSize: 1, refCount: false }));
    }
    return this.accountsCache$;
  }

  filterOrdersByBrand(brand: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}?vehicle_brand=${brand}`);
  }

  toggleActionRequired(reference: string): Observable<any> {
    const url = `${this.apiUrlNotes}/${reference}/action-required/toggle`;
    return this.http.put(url, {});
  }

  togglePrivateActionRequired(reference: string): Observable<any> {
    const url = `${this.apiUrlNotes}/${reference}/private-action-required/toggle`;
    return this.http.put(url, {});
  }
  
  updateActionRequiredBatch(
    noteIds: number[],
    actionRequired: boolean
  ): Observable<void> {
    return this.http.put<void>(`${this.apiUrlNotes}/action-required/toggle`, {
      references: noteIds,
      action_required: actionRequired,
    });
  }

  
  updatePrivateActionRequiredBatch(
    noteIds: number[],
    actionRequired: boolean
  ): Observable<void> {
    return this.http.put<void>(`${this.apiUrlNotes}/private-action-required/toggle`, {
      references: noteIds,
      action_required: actionRequired,
    });
  }

  closeView(order_rederence: string = ''): Observable<any> {
    const url = `${this.apiUrlW}/${order_rederence}/delete`;
    return this.http.delete(url);
  }
  updateView(order_rederence: string = ''): Observable<any> {
    const url = `${this.apiUrlW}/${order_rederence}/update`;
    return this.http.put(url, {});
  }

  checkVin(order_rederence: string = '', reference: string = ''): Observable<any> {
    const url = `${this.apiUrl}/${order_rederence}/vin/${reference}`;
    return this.http.get(url);
  }

  checkLicensePlate(order_rederence: string = '', reference: string = ''): Observable<any> {
    const url = `${this.apiUrl}/${order_rederence}/license-plate/${reference}`;
    return this.http.get(url);
  }
  getPrivateActionRequiredCount(): Observable<any> {
    return this.http.get<any>(`${this.apiUrlNotes}/last/private/action-required`);
  }

  getActionRequiredCount(): Observable<any> {
    return this.http.get<any>(`${this.apiUrlNotes}/last/action-required`);
  }

  private actionRequiredCountSource = new BehaviorSubject<number>(0);
  private actionRequiredCountAgentSource = new BehaviorSubject<number>(0);
  private privateActionRequiredCountSource = new BehaviorSubject<number>(0);
  actionRequiredCount$ = this.actionRequiredCountSource.asObservable();
  actionRequiredCountAgent$ = this.actionRequiredCountAgentSource.asObservable();
  privateActionRequiredCount$ = this.privateActionRequiredCountSource.asObservable();

  updateActionRequiredCount(count: number): void {
    this.actionRequiredCountSource.next(count);
  }

  updatePrivateActionRequiredCount(count: number): void {
    this.privateActionRequiredCountSource.next(count);
  }

  updateActionRequiredCount2(count: number): void {
    this.actionRequiredCountAgentSource.next(count);
  }

  initializeActionRequiredAutoUpdate(): void {
    this.visibilityPolling.register('action-required-count', () => {
      this.getActionRequiredCount().subscribe({
        next: (response) => {
          const count = response.data?.inbox_action_requireds || 0;
          this.updateActionRequiredCount(count);
          const count2 = response.data?.agent_inbox_action_requireds || 0;
          this.updateActionRequiredCount2(count2);
        },
        error: (err) => {
          console.error(
            'Error al actualizar automáticamente el número de notas:',
            err
          );
        },
      });
    }, 180000);
  }

  // Método para obtener datos del calendario de entregas
  getCalendarData(
    startDate: string,
    endDate: string,
    params: any = {},
    fieldDate: string = 'delivery_expected_date',
    sortColumn: string = 'vendor_reference,supplier_reference,vendor_quote_reference,created_at',
    sortDirection: string = 'asc,asc,asc,asc',


  ): Observable<any> {
    const params2 = new HttpParams()
      .set('start_date', startDate)
      .set('end_date', endDate)
      .set('field_date', fieldDate)
      .set('sortColumn', sortColumn)
      .set('sortDirection', sortDirection);

    return this.http.get(`${this.apiUrl}/calendar`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        field_date: fieldDate,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        ...params,
      },
    });


  }

  getPublicOrder(reference: string, token: string): Observable<any> {
    const url = `${this.apiUrlPublic}public/orders/${reference}/documents?token=${token}`;
    return this.http.get(url).pipe(
      map(response => response)
    );
  }

  updatePublicOrder(reference: string, token: string, updateData: any): Observable<any> {
    const url = `${this.apiUrlPublic}public/orders/${reference}/update?token=${token}`;
    return this.http.put(url, updateData).pipe(
      map(response => response)
    );
  }

  uploadPublicDocument(reference: string, token: string, file: File): Observable<any> {
    const url = `${this.apiUrlPublic}public/orders/${reference}/documents?token=${token}`;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', 'offer');
    return this.http.post(url, formData);
  }

  markOrderAsReceived(reference: string, token: string): Observable<any> {
    const url = `${this.apiUrl}/public/orders/${reference}/received?token=${token}`;

    return this.http.post(url, {}).pipe(map((response) => response));
  }

  getPublicNotDeliveredOrders(token: string): Observable<any> {
    return this.http.get(`${this.apiUrlPublic}public/not-delivered/${token}`).pipe(
      map(response => response)
    );
  }

  updatePublicNotDeliveredOrder(token: string, reference: string, body: any): Observable<any> {
    return this.http.patch(
      `${this.apiUrlPublic}public/not-delivered/${token}/orders/${reference}`,
      body
    ).pipe(map(response => response));
  }

  confirmPublicNotDeliveredOrder(token: string, reference: string): Observable<any> {
    return this.http.post(
      `${this.apiUrlPublic}public/not-delivered/${token}/orders/${reference}/confirm`,
      {}
    ).pipe(map(response => response));
  }

  undoPublicNotDeliveredOrder(token: string, reference: string): Observable<any> {
    return this.http.post(
      `${this.apiUrlPublic}public/not-delivered/${token}/orders/${reference}/undo`,
      {}
    ).pipe(map(response => response));
  }

  getTelemarketingStatusData(): Observable<any> {
    return this.http.get<any>(`${this.apiUrlPublic}telemarketing-status-data`);
  }

  getAvailableStages(type: string): Observable<any> {
    const stageType = type || 'all';
    return this.http.get(`${this.apiUrl}/stages/available/${stageType}`);
  }

  bulkUpdateStage(payload: BulkUpdatePayload): Observable<BulkUpdateResponse> {
    const url = `${this.apiUrl}/bulk/update-stage`;
    return this.http.patch<BulkUpdateResponse>(url, payload);
  }
}

